import * as api from '@/store/api';
import { OwnerFolder } from '@/store/models/LetterOwner/OwnerFolder';
import { LetterOwner } from '@/store/models/LetterOwner/LetterOwner';
import { LetterOwnerWithFaxAndEmails } from '@/store/models/LetterOwner/LetterOwnerWithFaxAndEmails';
import { LetterOwnerWithSendingInformationAndAttachments } from '../models/LetterOwner/LetterOwnerWithSendingInformationAndAttachments';
import { LetterOwnerForSendingFaxAndEmailAndSms } from '../models/LetterOwner/LetterOwnerForSendingFaxAndEmailAndSms';
import { CompanyLetterOwner } from '../models/LetterOwner/CompanyLetterOwner';
import { PhoneBook } from '../models/LetterOwner/PhoneBook';
import { PersonnelPhonebookContactInfo } from '../models/LetterOwner/PersonnelPhonebookContactInfo';
import { CompanyPersonnelPhonebookContactInfo } from '../models/LetterOwner/CompanyPersonnelPhonebookContactInfo';
import {GroupedLetterOwnersByCompanyDto} from '@/store/models/LetterOwner/GroupedLetterOwnersByCompanyDto'; 

export async function getArchiveFolders(ownerId: string): Promise<OwnerFolder[]>{
    try {
        const serverResult =  await api.batisAutomationApi.post("/LetterOwners/ArchiveFolders",{ownerId: ownerId});
        return serverResult.data as OwnerFolder[];
    } 
    catch (error) {
        console.log(error);
        return {} as OwnerFolder[];    
    }
}

export async function getOwnerRecipients(ownerId: string): Promise<LetterOwnerWithFaxAndEmails[]>{
    try {
        const serverResult =  await api.batisAutomationApi.post("/LetterOwners/Recipients",{ownerId: ownerId});
        return serverResult.data as LetterOwnerWithFaxAndEmails[];
    } 
    catch (error) {
        console.log(error);
        return {} as LetterOwnerWithFaxAndEmails[];    
    }
}
export async function getOwnerForwardRecipients(ownerId: string,formId: string): Promise<LetterOwnerWithFaxAndEmails[]>{
    try {
        const serverResult =  await api.batisAutomationApi.post("/LetterOwners/ForwardRecipients",{ownerId: ownerId,enterpriseFormId: formId});
        return serverResult.data as LetterOwnerWithFaxAndEmails[];
    } 
    catch (error) {
        console.log(error);
        return {} as LetterOwnerWithFaxAndEmails[];    
    }
}
export async function getOwnerRecipientsForAnnouncementBoard(ownerId: string,announcementBoardId: string): Promise<LetterOwnerWithFaxAndEmails[]>{
    try {
        const serverResult =  await api.batisAutomationApi.post("/LetterOwners/Recipients",{ownerId: ownerId});
        return serverResult.data as LetterOwnerWithFaxAndEmails[];
    } 
    catch (error) {
        console.log(error);
        return {} as LetterOwnerWithFaxAndEmails[];    
    }
}
export async function getCompanyPersonnelContactInfo(id: string): Promise<CompanyPersonnelPhonebookContactInfo>{
    try {
        const serverResult =  await api.batisAutomationApi.post("/LetterOwners/GetCompanyPersonnelContactInfo",{Id: id});
        return serverResult.data as CompanyPersonnelPhonebookContactInfo;
    } 
    catch (error) {
        console.log(error);
        return {} as CompanyPersonnelPhonebookContactInfo;    
    }
}

export async function getPersonnelContactInfo(id: string): Promise<PersonnelPhonebookContactInfo>{
    try {
        const serverResult =  await api.batisAutomationApi.post("/LetterOwners/GetPersonnelContactInfo",{Id: id});
        return serverResult.data as PersonnelPhonebookContactInfo;
    } 
    catch (error) {
        console.log(error);
        return {} as PersonnelPhonebookContactInfo;    
    }
}
export async function getAllPhoneBooks(): Promise<PhoneBook[]>
{
    try {
        const config = {
            headers: {'Content-Type': 'application/json' }
        };
        const data = {

        };
        const serverResult = await api.batisAutomationApi.post("/LetterOwners/GetAllPhonebook",data,config);
        // console.log("*************************");
        // console.log(serverResult.data);
        // console.log("*************************");
        return serverResult.data as PhoneBook[];
    } catch (error) {
        console.log(error);
        return [];
    }
   
}
export async function getAllLetterOwners(): Promise<LetterOwner[]>{
    try {
        const serverResult =  await api.batisAutomationApi.post("/LetterOwners/All",{});
        return serverResult.data as LetterOwner[];
    } 
    catch (error) {
        console.log(error);
        return {} as LetterOwner[];    
    }
}

export async function getAllCompanyLetterOwners(): Promise<LetterOwner[]>{
    try {
        const serverResult =  await api.batisAutomationApi.post("/LetterOwners/CompanyLetterOwners",{});
        return serverResult.data as LetterOwner[];
    } 
    catch (error) {
        console.log(error);
        return {} as LetterOwner[];    
    }
}
export async function getAllPersonnelLetterOwners(): Promise<LetterOwner[]>{
    try {
        const serverResult =  await api.batisAutomationApi.post("/LetterOwners/PersonnelLetterOwners",{});
        return serverResult.data as LetterOwner[];
    } 
    catch (error) {
        console.log(error);
        return {} as LetterOwner[];    
    }
}

export function getLetterOwnerWithSendingInfo(recipient: LetterOwnerWithFaxAndEmails): LetterOwnerWithSendingInformationAndAttachments{
    const result = {} as LetterOwnerWithSendingInformationAndAttachments;
    result.id = recipient.id;
    result.name = recipient.name;
    result.nameOnly = recipient.nameOnly;
    result.post = recipient.post;
    result.ownerType = recipient.ownerType;
    result.emails = [];
    if(recipient.emails)
        recipient.emails.forEach(email=>{
            result.emails.push(email);
        });
    result.shallReceiveSms = false;
    result.shallReceiveMessageViaMessagingApp = false;
    result.attachments = [];
    return result;
}
export function getLetterOwnerForSendingFaxAndEmailAndSms(recipient: LetterOwnerWithFaxAndEmails): LetterOwnerForSendingFaxAndEmailAndSms{
    const result = {} as LetterOwnerForSendingFaxAndEmailAndSms;
    result.id = recipient.id;
    result.name = recipient.name;
    result.nameOnly = recipient.nameOnly;
    result.post = recipient.post;
    result.ownerType = recipient.ownerType;
    result.emails = [];
    result.faxes = [];
    if(recipient.emails )
        recipient.emails.forEach(email=>{
            if(result.emails)
                result.emails.push(email);
        });
    if(recipient.faxes )
        recipient.faxes.forEach(fax=>{
            if(result.faxes)
                result.faxes.push(fax);
        });
    result.shallSendSms = false;
    result.shallSendViaMessagingApp = false;
    result.childDraftReceivers = [];
    result.childCopyReceivers = [];
    result.childMainReceivers = [];
    result.canUserSendEmail = recipient.canUserSendEmail;
    result.canUserSendFax = recipient.canUserSendFax;
    result.canUserSendSms = recipient.canUserSendSms;
    result.canSendViaMessagingApp = recipient.canSendViaMessagingApp;
    result.defaultSendComment=recipient.defaultSendComment;
    result.defaultSendCopyComment=recipient.defaultSendCopyComment;
    result.defaultSendDraftComment=recipient.defaultSendDraftComment;
    return result;
}


export async function getAllGroupedByCompany(): Promise<GroupedLetterOwnersByCompanyDto[]>{
    try {
        const serverResult =  await api.batisAutomationApi.post("/LetterOwners/groupedbycompany",{});
        return serverResult.data as GroupedLetterOwnersByCompanyDto[];
    } 
    catch (error) {
        console.log(error);
        return {} as GroupedLetterOwnersByCompanyDto[];    
    }
}
